export const UPDATE_LOAD_PROSPECT = 'UPDATE_LOAD_PROSPECT'; 
export const RESET_STATE = 'RESET_STATE';